<template>
  <div class="mt-4">
    <SoExpansionPanels>
      <SoExpansionPanel bg-color="surface" class="so-expansion-panel">
        <template #title
          ><p>Supply history for {{ address }}</p></template
        >
        <template v-if="supplyHistoryIsLoading">
          <SoSkeleton
            v-for="n in current.meterpoints.data"
            :key="n.id"
            type="image"
            class="my-4"
          />
        </template>
        <template
          v-for="(data, index) in supplyHistoriesFormatted"
          v-else
          :key="index"
        >
          <div class="d-flex justify-space-between align-center">
            <MeterpointHeader
              :meterpoint="current.meterpoints.data[index]"
              class="mt-4 mb-2"
            />
            <SoTooltip text="Last Meter Reading">
              <SoStatus
                :status="
                  current.meterpoints.data.find(
                    (m) => m.id === current.meterpoints.data[index].id,
                  )?.latestReadStatus
                "
              />
            </SoTooltip>
          </div>
          <SoSimpleTable
            :headers="['Date', 'Event', 'Status']"
            :items="data"
            class="mb-2"
            outlined
          />
        </template>
      </SoExpansionPanel>
    </SoExpansionPanels>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { MeterpointService } from "@/services/MeterpointService"
  import { formatDate } from "@/helpers/dateHelper"
  import SoExpansionPanel from "@/components/expansionPanels/SoExpansionPanel.vue"
  import SoExpansionPanels from "@/components/expansionPanels/SoExpansionPanels.vue"
  import SoSimpleTable from "@/components/SoSimpleTable.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import SoTooltip from "@/components/SoTooltip.vue"
  import MeterpointHeader from "../../components/MeterpointHeader.vue"

  export default defineComponent({
    components: {
      SoExpansionPanel,
      SoExpansionPanels,
      SoSimpleTable,
      SoSkeleton,
      SoStatus,
      SoTooltip,
      MeterpointHeader,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
    computed: {
      address() {
        return this.current.account?.data.supplyAddress?.formattedAddress
      },
      supplyHistories() {
        return this.current.meterpoints.data.map((m) =>
          MeterpointService.getMeterpointSupplyHistory(m.id),
        )
      },
      supplyHistoriesFormatted() {
        return this.supplyHistories.map((m) =>
          m.data.map((value) => [
            formatDate(value.date),
            value.eventType,
            value.supplyStatus,
          ]),
        )
      },
      supplyHistoryIsLoading() {
        return (
          this.current.meterpoints.isFetching ||
          this.supplyHistories.some((m) => m.isFetching)
        )
      },
    },
  })
</script>

<style scoped>
  .v-expansion-panel {
    border: 1px solid rgb(var(--v-theme-border));
    border-radius: var(--theme-radius);
    padding: 16px 24px;
    & p {
      font-weight: normal;
    }
  }
</style>
